import { createSlice } from "@reduxjs/toolkit";

export interface StoreLoaders {
  loading: string[];
}

export const initLoaders: StoreLoaders = {
  loading: [],
};

export const loaderSlice = createSlice({
  name: "loaders",
  initialState: initLoaders,
  reducers: {
    startLoading: (state, action: { payload: string | string[] }) => {
      if (Array.isArray(action.payload)) {
        action.payload.forEach((item) => {
          if (state.loading.indexOf(item) === -1) {
            state.loading.push(item);
          }
        });
        return;
      } else if (state.loading.indexOf(action.payload) === -1) {
        state.loading.push(action.payload);
      }
    },
    endLoading: (state, action: { payload: string }) => {
      const index = state.loading.indexOf(action.payload);
      if (index !== -1) {
        state.loading.splice(index, 1);
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { startLoading, endLoading } = loaderSlice.actions;

export default loaderSlice.reducer;
